import { useTranslations } from "next-intl";
import classNames from "classnames";
import { useButtonEventTracking } from "@hooks/use-button-event-tracking";
import IconSvg from "../IconSvg";

function CreateUserListCard({ onClick, trackingName, className }) {
  const t = useTranslations("common");

  const trackEvent = useButtonEventTracking();

  function handleClick() {
    trackEvent(trackingName);

    onClick();
  }

  return (
    <button
      className="btn-transparent w-100"
      onClick={handleClick}
    >
      <div className={classNames("userlist-horizontal-card", className)}>
        <div className="userlist-horizontal-card-content">
          <div className="userlist-horizontal-card-infos">
            <p className="mb-0 font-weight-bold">{t("userlist.create")}</p>
            <p className="mb-0 font-size-sm">{t("userlist.order_them")}</p>
          </div>
          <div className="userlist-horizontal-card-actions create-btn">
            <div className="image-container">
              <IconSvg name="symbol-increase" />
            </div>
          </div>
        </div>
      </div>
    </button>
  );
}

export default CreateUserListCard;
